import {
  getPrintContentForPc,
  findShopTemplate,
  getUnNotifiedOrders,
  setIsNotified,
  modifyPushInfo,
  handleOrder
} from '@/api'
import { getLodop } from '@/utils/LodopFuncs.js'
import { Notification } from 'element-ui'
import md5 from "js-md5";
const CryptoJS = require("crypto-js");
const PahoMQTT = require('paho-mqtt')
let LODOP = null
let isUseHttp = false
let basePath = 'https://www.madiancan.com/'
if (!!~location.href.indexOf('192.168')) {
  basePath = 'https://www.madiancan.com/'
}
let deviceCode = +new Date()

const setMqtt = () => {
  const config = {
    host: 'post-cn-4590s0h3b04.mqtt.aliyuncs.com', // 设置当前用户的接入点域名，接入点获取方法请参考接入准备章节文档，先在控制台创建实例
    port: 443, //WebSocket 协议服务端口，如果是走 HTTPS，设置443端口
    topic: 'ydcxd', //需要操作的 Topic
    useTLS: true, //是否走加密 HTTPS，如果走 HTTPS，设置为 true
    accessKey: 'LTAIIe8dsko2dFc1', //账号的 AccessKey，在阿里云控制台查看
    secretKey: 'qGGK1on9p6eRiatCWhAImvfqMdZkVk', //账号的的 SecretKey，在阿里云控制台查看
    cleansession: true,
    groupId: 'GID_ydcxd',
    // clientId: 'GID_ydcxd' + '@@@' + md5(localStorage.userId + localStorage.sessionId).toUpperCase() //GroupId@@@DeviceId，由控制台创建的 Group ID 和自己指定的 Device ID 组合构成
  }
  let mqtt, message, reconnectTimeout = 2000,
    username = config.accessKey,
    password = CryptoJS.HmacSHA1(config.groupId, config.secretKey).toString(CryptoJS.enc.Base64);

  function MQTTconnect() {
    config.clientId = localStorage.sessionId ? 'GID_ydcxd' + '@@@' + md5(localStorage.userId + localStorage.sessionId).toUpperCase() : ""
    console.log(config.clientId)
    mqtt = new PahoMQTT.Client(
      config.host, //MQTT 域名
      config.port, //WebSocket 端口，如果使用 HTTPS 加密则配置为443,否则配置80
      config.clientId //客户端 ClientId
    );
    let options = {
      timeout: 3,
      onSuccess: onConnect,
      mqttVersion: 4,
      onFailure: function (message) {
        console.log("fail", message)
        setTimeout(MQTTconnect, reconnectTimeout);
      }
    };

    mqtt.onConnectionLost = onConnectionLost;
    mqtt.onMessageArrived = onMessageArrived;
    if (username != null) {
      options.userName = username;
      options.password = password;
      options.useSSL = config.useTLS; //如果使用 HTTPS 加密则配置为 true
    }
    mqtt.connect(options);
  }

  function onConnect() {
    if (!localStorage.sessionId) throw new Error
    if (localStorage.sessionId) {
      console.log('onConnect')
      mqtt.subscribe(config.topic, { qos: 0 });
      if (localStorage.deviceCode) {
        deviceCode = localStorage.deviceCode
      } else {
        localStorage.deviceCode = deviceCode;
      }
      modifyPushInfo({
        channelId: md5(localStorage.userId + localStorage.sessionId).toUpperCase(),
        deviceCode: deviceCode,
        usePl: 102
      })
    }
    // message = new Paho.MQTT.Message("Hello mqtt!!");//set body
    // message.destinationName = config.topic;// set topic
    // mqtt.send(message);
  }

  function onConnectionLost(response) {
    console.log('onConnectionLost')
    if (localStorage.connectErrorNum && localStorage.sessionId) {
      console.log(localStorage.connectErrorNum, localStorage.connectErrorNum >= 3, !isUseHttp)
      if (localStorage.connectErrorNum >= 3 && !isUseHttp) {
        useHttpMessage()
        return
      }
      localStorage.connectErrorNum++
    } else {
      localStorage.connectErrorNum = 1
    }
    setTimeout(MQTTconnect, reconnectTimeout);
  };

  function onMessageArrived(message, ackServerCallback) {
    console.log('收到message:' + JSON.stringify(message) + config.clientId)
    let data = message.payloadString;
    if ('' == data) {
      //只播放声音
      playSound();
    } else {
      if (data.indexOf("{") == -1) return
      console.log(JSON.parse(data))
      let notifyId = JSON.parse(data).notifyId
      messageFuc(data, notifyId, ackServerCallback)
    }
  };

  function useHttpMessage() {
    isUseHttp = true
    getUnNotifiedOrders().then(res => {
      console.log(res)
      if (res.code == 1) {
        res.data.forEach((val, index) => {
          setTimeout(() => {
            messageFuc(val[1], val[0])
            if (index + 1 == res.data.length) {
              localStorage.connectErrorNum = 0
              isUseHttp = false
            }
          }, index * 5e3)
        })
      } else {
        localStorage.connectErrorNum = 0
        isUseHttp = false
      }
    }).catch(e => {
      isUseHttp = false
    })
  }

  function checkOrders() {
    getUnNotifiedOrders().then(res => {
      console.log(res)
      if (res.code == 1) {
        if (res.data.length) {
          let notify = Notification({
            title: '你有未处理的订单',
            dangerouslyUseHTMLString: true,
            message: `<div>你有${res.data.length}条订单未处理</div>
            <div class="notification-html"><div class="btn print">打印</div><div class="btn ignore">忽略</div></div>`,
            duration: 0
          })
          document.querySelector(".btn.print").onclick = function () {
            console.log(1)
            res.data.forEach((val, index) => {
              setTimeout(() => {
                messageFuc(val[1], val[0])
                if (index + 1 == res.data.length) {
                  localStorage.connectErrorNum = 0
                  isUseHttp = false
                  notify.close()
                }
              }, index * 5e3)
            })
          }
          document.querySelector(".btn.ignore").onclick = function () {
            res.data.forEach((val, index) => {
              setIsNotified({
                notifyId: val[0],
              })
            })
            notify.close()
          }
          return
        }
      }
    })
  }
  checkOrders()
  //转换下属性名
  function changeBean(bean) {
    var newBean = {
      createTime: bean.createTime,
      number: bean.tradeNo,
      peopleNum: bean.mealsNum,
      orderDetailList: [],
      chPrice: '0.0',
      postPrice: bean.distributionPrice ? bean.distributionPrice : 0.0,
      subDesc: [],
      cardMoney: '0.0',
      payPrice: bean.payMoney,
      customerPhone: bean.buyerPhone,
      customerName: bean.buyerName,
      remark: bean.buyerMark,
      shopName: bean.shopName,
      model: bean.orderCategory == 3 ? 0 : 1,
      customerAddr: bean.buyerAddress,
      orderNum: bean.orderNum,
      printTempType: bean.printTempType
    }
    var foodBoxPrice = 0
    var products = bean.products
    for (var p in products) {
      newBean.orderDetailList.push({
        name: products[p].goodsName,
        price: products[p].turnoverPrice,
        specStr: products[p].specDesc,
        quantity: products[p].buyCount,
        goodsCategory: products[p].goodsCategory,
        productSaleStatus: products[p].productSaleStatus
      })
      //累加餐盒费
      foodBoxPrice +=
        (products[p].foodBoxPrice ? products[p].foodBoxPrice : 0) *
        products[p].buyCount
    }
    newBean.chPrice = foodBoxPrice.toFixed(1)
    return newBean
  }

  //转换成html
  function newChangeBean(bean) {
    var html = ''
    $(bean).each(function (index, bean) {
      var style_str = '' //    text-align: center;
      if (bean.alignType == 1) {
        // 1 左对齐 2 中间对其 3右对齐
        style_str += ' text-align: left;'
      } else if (bean.alignType == 2) {
        style_str += ' text-align: center;'
      } else if (bean.alignType == 3) {
        style_str += ' text-align: right;'
      }
      if (bean.isbold == 1) {
        //  是否加粗  1是  2 不加粗
        style_str += 'font-weight:bold;'
      }
      if (bean.isItalic == 1) {
        //  是否倾斜 1是 2 不倾斜
        style_str += 'font-style: italic;'
      }
      if (bean.txtSizeType == 1) {
        //字体大小 1 小 2中 3 大
        style_str += 'font-size: 11px;'
      } else if (bean.txtSizeType == 2) {
        style_str += 'font-size:12px;'
      } else if (bean.txtSizeType == 3) {
        style_str += 'font-size:17px;'
      }
      style_str += '    padding: 0 10%;'
      console.log(bean.txt.replace('\n', ''))
      html +=
        "<p style='" +
        style_str +
        "'>" +
        bean.txt.replace(new RegExp(' ', 'gm'), '-').replace('\n', '<br>') +
        '</p>'
    })

    return html
  }


  function messageFuc(data, notifyId, ackServerCallback = null) {
    var bean = JSON.parse(data)
    console.log(bean, notifyId, ackServerCallback)
    setIsNotified({
      notifyId: notifyId,
    })
    //判断订单是否是该商户的
    if (localStorage.shopId != bean.shopId) {
      return false
    }
    if (bean.noticeType == 2 || bean.noticeType == 1) {
      if (bean.noticeType == 2) {
        Notification({
          title: '提示',
          message: bean.buyerAddress + ' 的客户 加菜了,请注意处理~',
          type: 'warning',
          duration: 0
        })
      }
      //播放声音
      playSound()
      //打印订单
      // dayinOrder(bean);

      //用默认的 再打一遍

      //回调
      if (bean.noticeType == 1 && bean.isAutoTake == 1) {
        console.log('收到noticeType:' + data)
        handleOrder({
          mallOrderId: bean.mallOrderId,
          orderStatus: 20,
        }).then((res) => {
        });
        if (ackServerCallback) {
          ackServerCallback(bean.mallOrderId)
        }
      }
    } else if (bean.noticeType == 3) {
      //打印

      getPrintContnet(bean)
    }
  }

  function getPrintContnet(bean) {
    console.log(bean)
    //根据订单id 获取小票信息
    getPrintContentForPc({
      mallOrderId: bean.mallOrderId,
      groupId: bean.groupId,
      goodsCategorys: bean.goodsCategorys,
      printerDevicesId: bean.printerDevicesId,
      printStage: bean.printStage || '',
      goodsIds: bean.goodsIds
    }).then(data => {
      if (data.code == 1) {
        if (!data.data.htmlContent) return
        newDayinOrder(
          data.data.htmlContent,
          bean.deviceIdentifier,
          bean.pageWidth,
          bean.printPageNum
        )
      } else {
        // alert(data.msg)
      }
    })
  }

  function newDayinOrder(htmlContent, deviceIdentifier, pageWidth, printPageNum) {
    newDayinOrderSub(htmlContent, deviceIdentifier, pageWidth, printPageNum)
  }

  function dayinOrder(json) {
    var oldValue = JSON.parse(localStorage.getItem('printIndex'))
    if (oldValue) {
      //循环 打印设备 打印
      for (var o in oldValue) {
        dayinOrderSub(json, oldValue[o].index)
      }
    } else {
      dayinOrderSub(json, -1) //没设置过 就用默认打印机
    }
  }

  function strlen(str) {
    var len = 0
    for (var i = 0; i < str.length; i++) {
      var c = str.charCodeAt(i)
      //单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++
      } else {
        len += 2
      }
    }
    return len
  }

  function newDayinOrderSub(htmlContent, printerIndex, pageWidth, printPageNum) {
    if (localStorage.getItem("printStatus") && localStorage.getItem("printStatus") == "false") {
      return
    }
    //var template_html="<div style='margin-left: -20px'>"+htmlContent+"</div>";
    // var template_html =
    // "<div style='margin-left: -20px;padding:20px;'>" + htmlContent + '</div>'
    var template_html = htmlContent
    if (pageWidth == 80) {
      // template_html="<div style='margin-left: 0px'>"+htmlContent+"</div>";
    }
    // console.log(template_html);
    // console.log(pageWidth);
    //  $("#ttt").html(template_html);
    LODOP = getLodop()
    if (!LODOP) {
      if (confirm('打印机连接失败,查看解决方案？')) {
        window.location.href = basePath + 'print/tip.html'
      } else {
        return
      }
    }
    console.log(template_html)
    LODOP.PRINT_INIT('订单小票')
    LODOP.ADD_PRINT_HTM(0, 10, '100%', '100%', template_html)
    LODOP.SET_PRINT_COPIES(printPageNum) //设置打印份数
    LODOP.SET_PRINT_PAGESIZE(3, pageWidth * 10, 40, '')
    // LODOP.PREVIEW();
    LODOP.SET_PRINTER_INDEXA(printerIndex)
    LODOP.PRINT()
  }

  function dayinOrderSub(json, printerIndex) {
    var origin_data = json
    json = changeBean(json)
    LODOP = getLodop()

    if (!LODOP) {
      if (confirm('打印机连接失败,查看解决方案？')) {
        window.location.href = basePath + 'print/tip.html'
      } else {
        return
      }
    }

    LODOP.PRINT_INIT(json.shopName + '订单小票')
    LODOP.SET_PRINT_STYLE('FontSize', 14)
    LODOP.SET_PRINT_STYLE('Bold', 1)

    if (json.model == 0) {
      var title = '*外卖*'
      var pay_title = '已在线支付'
      var if_show_ch = true
      var if_show_ship = true
      var customerName = json.customerName
      var customerPhone = json.customerPhone
      var if_show_address = true
    } else {
      var title = '*堂食*'
      var pay_title = '未支付'
      var if_show_ch = false
      var if_show_ship = false
      var customerName = json.customerAddr + '号桌'
      var customerPhone = json.peopleNum + '人用餐'
      var if_show_address = false
    }

    if (json.printTempType == null || json.printTempType == '') {
      findShopTemplate().then(res => {
        if (res.code == 1) {
          json.printTempType = res.data
        }
      })
    }
    if (json.printTempType == 2) {
      group_result = json.orderDetailList.reduce(function (h, obj) {
        h[obj.goodsCategory] = (h[obj.goodsCategory] || []).concat(obj)
        return h
      }, {})
    }

    template_html =
      '\t<form id="form1">\n' +
      '\t\t<h3 style="text-align: center;font-size: 14px;">' +
      json.shopName +
      '</h3>\n' +
      '\t\t<p class="split-line"> <span  class="words">' +
      pay_title +
      '</span>   <span class="line" style=\'float:left\'></span>      <span class="line" style=\'float: right;\'></span></p>\n' +
      '\t\t<style>\n' +
      '\n' +
      '\t\t\t.split-line .line{\n' +
      '\t\t\t\twidth: 25%;\n' +
      '\t\t\t\tborder-bottom: 1px solid #ecddeb;margin-top: -9px;\n' +
      '\t\t\t\tdisplay: inline-block;\n' +
      '\t\t\t}\n' +
      '\n' +
      '\t\t\t.split-line .words{\n' +
      '\t\t\t\twidth: 100%;\n' +
      '\t\t\t\tdisplay: inline-block;\n' +
      '\t\t\t\ttext-align: center;\n' +
      '\t\t\t\tfont-size: 14px;\n' +
      '\t\t\t}\n' +
      '\n' +
      '\t\t\t#form1 {\n' +
      '\t\t\t\ttext-align: left;\n' +
      '\t\t\t\tmax-width: 200px;\n' +
      '\t\t\t\tmargin: auto;\n' +
      '\t\t\t\tpadding: 20px 10px;\n' +
      '\t\t\t}\n' +
      '\n' +
      '\t\t\t.section {\n' +
      '\t\t\t\tborder-bottom: 1px solid #ecddeb;\n' +
      '\t\t\t\tpadding-bottom: 8px;\n' +
      '\t\t\t}\n' +
      '\n' +
      '\t\t\t.footer span {\n' +
      '\t\t\t\tfloat: right;\n' +
      '\t\t\t}\n' +
      '\n' +
      '\t\t\tp {\n' +
      '\t\t\t\tfont-size: 12px;\n' +
      '\t\t\t\tmargin: 8px auto;\n' +
      '\t\t\t}\n' +
      '\n' +
      '\t\t\t.large-text {\n' +
      '\t\t\t\tfont-size: 14px;\n' +
      '\t\t\t\tmargin: 10px auto;\n' +
      '\t\t\t}\n' +
      '\n' +
      '\t\t\t.phone {\n' +
      '\t\t\t\tmargin-left: 15px;\n' +
      '\t\t\t}\n' +
      '\n' +
      '\t\t\t.payment span {\n' +
      '\t\t\t\tfloat: right;\n' +
      '\t\t\t}\n' +
      '\t\t\t.col-7{\n' +
      '\t\t\t\twidth: 65%;\n' +
      '\t\t\t\tdisplay: inline-block;\n' +
      '\t\t\t}\n' +
      '\t\t\t.col-1{\n' +
      '\t\t\t\twidth: 15%;\n' +
      '\t\t\t\tdisplay: inline-block;\n' +
      '\t\t\t}\n' +
      '\t\t\t.col-2{\n' +
      '\t\t\t\twidth:20%;\n' +
      '\t\t\t\tdisplay: inline-block;\n' +
      '\t\t\t\ttext-align: right;\n' +
      '\t\t\t}\n' +
      '\t\t\t.items{\n' +
      '\t\t\t\tmargin: 8px auto;\n' +
      '\t\t\t\tfont-size: 12px;\n' +
      '\t\t\t}\n' +
      '\t\t</style>\n' +
      '\t\t<div class="section">\n' +
      '\t\t\t<p class="large-text" style="margin:20px auto">' +
      title +
      ' #' +
      json.orderNum +
      '</p>\n' +
      '\t\t\t<p>单号：' +
      json.number +
      '</p>\n' +
      '\t\t\t<p>下单时间：' +
      json.createTime +
      '</p>\n' +
      '\t\t</div>\n' +
      '\t\t<div class="section">\n' +
      '\t\t\t<div class="items" style="margin-bottom:10px;"><div class="col-7">菜名/规格</div><div class="col-1">数量</div><div class="col-2">小计</div></div>\n' +
      '\n'

    if (json.printTempType == 2) {
      for (var category in group_result) {
        console.log(category)

        var items = group_result[category]

        template_html +=
          '\t\t\t<div class="types">\n' +
          '\t\t\t\t<p class="large-text"  style=\'font-size:17px;\'>' +
          category +
          '</p>\n'

        items.forEach(item => {
          var status_array = ['', '退', '', '换', '赠']
          template_html +=
            '\t\t\t\t<div class="items"><div class="col-7">' + item.name
          template_html += status_array[item.productSaleStatus]
            ? "<span style='float:right;margin-right:5px'>" +
            status_array[item.productSaleStatus] +
            '</span>'
            : ''
          template_html +=
            '</div><div class="col-1">X' +
            item.quantity +
            '</div><div class="col-2">' +
            item.price +
            '</div></div>\n'
        })

        template_html += '\t\t\t</div>\n' + '\n'
      }

      template_html += '\t\t\t</div>\n'
    } else {
      template_html += '\t\t\t<div class="types">\n'

      json.orderDetailList.forEach(item => {
        var status_array = ['', '退', '', '换', '赠']
        template_html +=
          '\t\t\t\t<div class="items"><div class="col-7">' + item.name
        template_html += status_array[item.productSaleStatus]
          ? "<span style='float:right;margin-right:5px'>" +
          status_array[item.productSaleStatus] +
          '</span>'
          : ''
        template_html +=
          '</div><div class="col-1">X' +
          item.quantity +
          '</div><div class="col-2">' +
          item.price +
          '</div></div>\n'
      })

      template_html += '\t\t\t</div>\n' + '\t\t</div>\n'
    }

    template_html +=
      '\t\t<div class="section payment">\n' +
      '\t\t\t<p>总数 <span>' +
      json.orderDetailList.length +
      '</span></p>\n' +
      (if_show_ch
        ? '\t\t\t<p>餐盒费 <span>' + json.chPrice + '</span></p>\n'
        : '') +
      (if_show_ship
        ? '\t\t\t<p>配送费 <span>' + json.postPrice + '</span></p>\n'
        : '') +
      '\t\t\t<p>优惠 <span>' +
      json.cardMoney +
      '</span></p>\n' +
      '\t\t\t<p class="large-text">总计<span>' +
      json.payPrice +
      '</span></p>\n' +
      '\t\t</div>\n' +
      '\t\t<div class="section">\n' +
      '\t\t\t<p class="large-text">' +
      customerName +
      ' <span class="phone">' +
      customerPhone +
      '</span></p>\n' +
      '\t\t\t<p class="large-text">' +
      (if_show_address ? json.customerAddr : '') +
      '</p>\n' +
      '\t\t\t<p>备注: ' +
      (typeof remark != 'undefined' ? remark : '') +
      '</p>\n' +
      '\t\t</div>\n' +
      '\t\t<div class="footer">\n' +
      '\t\t\t<p>谢谢惠顾，欢迎下次光临 <span>码点餐#' +
      origin_data.shopId +
      '</span></p>\n' +
      '\t\t</div>\n' +
      '\t</form>'

    var printPageSet = JSON.parse(localStorage.getItem('printPageSet'))
    pageWidth = printPageSet ? printPageSet.pageWidth : 580
    LODOP.ADD_PRINT_HTM(0, 0, '100%', '100%', template_html)

    LODOP.SET_PRINT_PAGESIZE(3, pageWidth, 40, '')
    LODOP.PREVIEW()
    /* LODOP.SET_PRINTER_INDEXA(printerIndex);
       LODOP.PRINT();*/
  }

  function playSound() {
    console.log('playSound')
    // var borswer = window.navigator.userAgent.toLowerCase();
    // if (borswer.indexOf("ie") >= 0) {
    //     //IE内核浏览器
    //     var strEmbed = '<embed name="embedPlay" src="' + basePath + 'js/edcmanage/ding.mp3" autostart="true" hidden="true" loop="false"></embed>';
    //     if ($("#embedPlay").length <= 0)
    //         $("body").append(strEmbed);
    //     var embed = document.embedPlay;

    //     //浏览器不支持 audion，则使用 embed 播放
    //     embed.volume = 100;
    //     //embed.play();这个不需要
    // } else {
    //     //非IE内核浏览器
    //     var strAudio = "<audio id='audioPlay' src='" + basePath + "js/edcmanage/ding.mp3' hidden='true'>";
    //     if ($("#audioPlay").length <= 0)
    //         $("body").append(strAudio);
    //     var audio = document.getElementById("audioPlay");

    //     //浏览器支持 audion
    //     audio.play();
    // }
    let mp3 = `${basePath}js/edcmanage/ding.mp3`
    let audio = new Audio(mp3)
    audio.play() //播放 mp3这个音频对象
  }

  function playNOSound() {
    console.log('playNOSound')
    var borswer = window.navigator.userAgent.toLowerCase()
    if (borswer.indexOf('ie') >= 0) {
      //IE内核浏览器
      var strEmbed =
        '<embed name="embedPlay2" src="' +
        basePath +
        'js/edcmanage/ding.mp3" autostart="true" hidden="true" loop="false" muted="true"></embed>'
      if ($('#embedPlay2').length <= 0) $('body').append(strEmbed)
      var embed = document.embedPlay

      //浏览器不支持 audion，则使用 embed 播放
      embed.volume = 100
      //embed.play();这个不需要
    } else {
      //非IE内核浏览器
      var strAudio =
        "<audio id='audioPlay2' src='" +
        basePath +
        "js/edcmanage/ding.mp3' hidden='true' muted=\"true\">"
      if ($('#audioPlay2').length <= 0) $('body').append(strAudio)
      var audio = document.getElementById('audioPlay2')

      //浏览器支持 audion
      audio.play()
    }
    if ($('#audioPlay2').length <= 0 && $('#embedPlay2').length <= 0) {
      playNOSound()
      console.log('1111')
    }
  }
  MQTTconnect();
}

if (!window.ignoreList.some(r => location.hash.includes(r))) {
  setMqtt()
};